import React, { useCallback, useState } from "react";

import SearchFormSort from "./search_form_sort";
import SearchFormCalendar from "./search_form_calendar";

// イベント並べ替え
// app/controllers/concerns/search_concern.rbと一致
const sortEventKeys = {
  poplular: "popular",
  recently: "recently",
  weekend: "weekend",
  new: "new",
  circle: "circle",
  newCircle: "new_circle",
};

// 検索ワード補完
const searchTypes = { ec: "eventCondition", kw: "keyword" };
const searchCompletions = {
  人気イベント: {
    searchType: searchTypes.ec,
    sortEventKey: sortEventKeys.poplular,
  },
  オンライン: { searchType: searchTypes.kw },
};

const SearchForm = ({
  // categories,
  keyword,
  loadSearchResult,
  eventCondition,
  eventDate,
  timeSlot,
  companyId,
}) => {
  const [keywordDisp, setKeywordDisp] = useState(keyword);

  // 補完（入力時に自動ロード）
  const onSearchCompletion = useCallback(
    (value) => {
      const sc = searchCompletions[value];
      if (sc.searchType === searchTypes.ec) {
        setKeywordDisp("");
        loadSearchResult({
          keyword: "",
          circleOrder: "",
          eventCondition: sc.sortEventKey,
          eventDate: null,
        });
        return false;
      } else if (sc.searchType === searchTypes.kw) {
        loadSearchResult({
          circleOrder: "",
          eventCondition: "",
          keyword: value,
        });
      }
    },
    [setKeywordDisp, loadSearchResult]
  );

  // キーワード入力
  const _onChangeKeyword = useCallback(
    (e) => {
      if (Object.keys(searchCompletions).indexOf(e.target.value) !== -1) {
        onSearchCompletion(e.target.value); // datalistタグ補完時に自動ロード
      }
      setKeywordDisp(e.target.value);
    },
    [onSearchCompletion, setKeywordDisp]
  );

  // キーワード検索
  const _onKeyDown = useCallback(
    (e) => {
      if (e.keyCode === 13) {
        loadSearchResult({ keyword: keywordDisp });
        return false;
      }
    },
    [loadSearchResult, keywordDisp]
  );

  // 日付検索
  const eventDateFunc = useCallback(
    (dateStr) => {
      loadSearchResult({
        keyword: keywordDisp,
        circleOrder: "",
        eventCondition: eventCondition,
        eventDate: dateStr,
      });
    },
    [keywordDisp, loadSearchResult]
  );

  // 時間帯フィルタ変更
  const onChangeTimeSlot = useCallback(
    (newTimeSlot, customRange) => {
      const params = {
        keyword: keywordDisp,
        circleOrder: "",
        eventCondition: eventCondition,
        eventDate: eventDate,
        timeSlot: newTimeSlot,
      };
      if (newTimeSlot === "custom" && customRange) {
        params.timeSlotFrom = customRange.from;
        params.timeSlotTo = customRange.to;
      }
      loadSearchResult(params);
    },
    [keywordDisp, eventCondition, eventDate, loadSearchResult]
  );

  // ソート検索
  const sortEventFunc = useCallback(
    (sortEventKey) => {
      if (sortEventKey === sortEventKeys.poplular) {
        loadSearchResult({
          keyword: "",
          circleOrder: "",
          eventCondition: "",
          eventDate: eventDate,
        });
        setKeywordDisp("");
      } else {
        loadSearchResult({
          keyword: keywordDisp,
          circleOrder: "",
          eventCondition: sortEventKey,
          eventDate: eventDate,
        });
      }
    },
    [sortEventKeys, keywordDisp, loadSearchResult, setKeywordDisp]
  );

  return (
    <div className="pb-3">
      <div className="position-relative container mt-4 mb-4">
        <div className="row">
          <div className="col">
            <input
              type="text"
              className="m-search-textbox"
              value={keywordDisp}
              placeholder={companyId ? "キーワードでイベントを探す" : "キーワードで遊びを探す"}
              onChange={_onChangeKeyword}
              onKeyDown={_onKeyDown}
              autoComplete="on"
              list="mylist"
              inputMode="search"
            />
          </div>
        </div>
      </div>
      {eventCondition !== "circle" ? (
        <div className="search-event__body">
          <div className="container col-lg-8">
            <p className="search-event__heading">
              <img className="ls-is-cached lazyloaded" src="/assets2019/img/icon_calendar.svg" alt="" />
                {companyId ? "日時でイベント探そう" : "日時で遊びのイベント探そう"}
            </p>
            <SearchFormCalendar
              eventDate={eventDate}
              eventDateFunc={eventDateFunc}
            />
            <SearchFormSort
              sortEventKeys={sortEventKeys}
              sortEventFunc={sortEventFunc}
              eventCondition={eventCondition}
              eventDate={eventDate}
              eventDateFunc={eventDateFunc}
              timeSlot={timeSlot}
              onChangeTimeSlot={onChangeTimeSlot}
            />
          </div>
        </div>
      ) : (
        ""
      )}
    </div>
  );
};

export default SearchForm;